import { render, staticRenderFns } from "./CreateSections.vue?vue&type=template&id=098a807a&scoped=true"
import script from "./CreateSections.vue?vue&type=script&lang=js"
export * from "./CreateSections.vue?vue&type=script&lang=js"
import style0 from "./CreateSections.vue?vue&type=style&index=0&id=098a807a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098a807a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('098a807a')) {
      api.createRecord('098a807a', component.options)
    } else {
      api.reload('098a807a', component.options)
    }
    module.hot.accept("./CreateSections.vue?vue&type=template&id=098a807a&scoped=true", function () {
      api.rerender('098a807a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CreateSections.vue"
export default component.exports